export default __webpack_public_path__ + "static/media/header-img.bd4f4a77.jpg";